var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Close_2",
    d: "M16.2426 15.1871L13.0564 12.0009L16.2426 8.81468C16.3827 8.67459 16.4614 8.48459 16.4614 8.28647C16.4614 8.08836 16.3827 7.89836 16.2426 7.75827C16.1026 7.61818 15.9125 7.53947 15.7144 7.53947C15.5163 7.53947 15.3263 7.61818 15.1862 7.75827L12 10.9445L8.81378 7.75827C8.67369 7.61818 8.48368 7.53947 8.28557 7.53947C8.08745 7.53947 7.89745 7.61818 7.75736 7.75827C7.61727 7.89836 7.53857 8.08836 7.53857 8.28647C7.53857 8.48459 7.61727 8.67459 7.75736 8.81468L10.9436 12.0009L7.75736 15.1871C7.61727 15.3272 7.53857 15.5172 7.53857 15.7153C7.53857 15.9135 7.61727 16.1035 7.75736 16.2435C7.89745 16.3836 8.08745 16.4623 8.28557 16.4623C8.48369 16.4623 8.67369 16.3836 8.81378 16.2435L12 13.0573L15.1862 16.2435C15.3263 16.3836 15.5163 16.4623 15.7144 16.4623C15.9125 16.4623 16.1026 16.3836 16.2426 16.2435C16.3827 16.1035 16.4614 15.9135 16.4614 15.7153C16.4614 15.5172 16.3827 15.3272 16.2426 15.1871Z",
    fill: "#757280"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSvg);
export default __webpack_public_path__ + "static/media/CloseSvg.49db4451f4e5c3cef84e30afc3a79ff6.svg";
export { ForwardRef as ReactComponent };